export default {
  props: {
    showdialog: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialogVisible: function() {
      return this.showdialog;
    },
  },
  data() {
    return {
      ProjectObj: {
        '逐一': 1,
        '鹿城': 2,
        '车都': 4,
        '微停': 8,
        '龙港': 16,
        '上饶': 32,
        '武汉': 1,
        '停简单': 8,
        '岗亭': 8,
        '数发': 8,
        '萍乡': 8
      },
    }
  },
  methods:{
    handleClose(){
        this.$emit('update:showdialog',false)
      },
    formatDateTime(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? ('0' + m) : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      var h = date.getHours();
      h = h < 10 ? ('0' + h) : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? ('0' + minute) : minute;
      second = second < 10 ? ('0' + second) : second;
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':'+ second;
    },
    formatDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? ('0' + m) : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      return y + '-' + m + '-' + d;
    },
    formatTime(date, format) {
      var h = date.getHours();
      h = h < 10 ? ('0' + h) : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? ('0' + minute) : minute;
      second = second < 10 ? ('0' + second) : second;
      if (format === 'm:s') {
        return  minute + ':'+ second;
      } else if (format === 'h') {
        return h
      } else if (format === 'm') {
        return minute
      } else if (format === 's') {
        return second
      } else {
        return h + ':' + minute + ':'+ second;
      }
    },
  }
};
